export const evaluationRoutePaths = {
  evaluation: {
    path: 'evaluation',
    fullPath: '/evaluation',
  },
};
